import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

interface MultiLineCellRendererProps {
    value: string;
}

const muiStyles = makeStyles({
    root: {
        whiteSpace: 'normal' as const,
        height: '100%'
    },
    text: {
        lineHeight: '20px',
        wordBreak: 'break-word' as const
    }
});

const MultiLineCellRenderer = (props: MultiLineCellRendererProps) => {
    const { value } = props;

    const {
        root,
        text
    } = muiStyles(props);

    return (
        <Grid
            className={root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <span
                className={text}
                data-testid='multi-line-string'
            >{value}
            </span>
        </Grid>
    );
};

export default MultiLineCellRenderer;